import React from 'react';
import { Header } from '@features/header/Header';

interface W2ShellProps {
  title?: string;
  description?: React.ReactNode;
  children: React.ReactNode;
  /** Add authenticated W2 chrome without changing public/link-error shells. */
  showLogout?: boolean;
}

/**
 * Minimal, self-contained layout for W2 terminal and transient states. It does
 * not mount the stateful B2C auth/onboarding layouts; authenticated callers can
 * opt into the shared branded Header solely for the permanent W2 logout action.
 */
export const W2Shell: React.FC<W2ShellProps> = ({
  title,
  description,
  children,
  showLogout = false,
}) => {
  const card = (
    <div className="w-full max-w-[560px] rounded-2xl bg-white shadow-sm border border-[#ececf2] p-8 max-sm:p-6">
      {title && (
        <h1 className="text-3xl font-extrabold text-[#1a1a2e] mb-2 max-sm:text-2xl">
          {title}
        </h1>
      )}
      {description && (
        <div className="text-[#5a5a70] text-base leading-6 mb-6">
          {description}
        </div>
      )}
      {children}
    </div>
  );

  if (showLogout) {
    return (
      <div className="mx-auto flex min-h-screen w-full max-w-[1920px] flex-col gap-3.5 bg-[#f6f7fb] py-3.5 pb-6 lg:gap-6 lg:pt-5">
        <Header showW2Logout />
        <main className="flex flex-1 items-center justify-center px-4 py-10">
          {card}
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full bg-[#f6f7fb] flex items-center justify-center px-4 py-10">
      {card}
    </div>
  );
};
